import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/app/constants/constants';
import { ApproverMapModel } from 'src/app/core/models/ApproverMapModel';
import { CompanyModel } from 'src/app/core/models/CompanyModel';
import { DepartmentModel } from 'src/app/core/models/DepartmentModel';
import { HolidayModel } from 'src/app/core/models/HolidayModel';
import { RegisteredUserModel } from 'src/app/core/models/RegisteredUserModel';
import { SubDepartmentModel } from 'src/app/core/models/SubDepartmentModel';
import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };  
  private httpLoaderHeader = { headers: new HttpHeaders().set(Constants.SKIP_LOADER_HEADER_KEY, 'true') };
  constructor(private baseService: BaseService) {
    
}

getAllApprovers(): Observable<any> {  
  return this.baseService.get<any>('ApproverMapping/GetAllApprovers');
}

getAllRegisteredUsers(skipLoader: boolean = false): Observable<any> {
  return this.baseService.get<any>('User/GetAllRegisteredUsers', skipLoader ? this.httpLoaderHeader : {});
}

getAllRegisteredPartners(skipLoader: boolean = false): Observable<any> {
  return this.baseService.get<any>('User/GetAllRegisteredPartners', skipLoader ? this.httpLoaderHeader : {});
}

addUser(model: RegisteredUserModel): Observable<any> {
  return this.baseService.post('User/AddUser', JSON.stringify(model), this.options);
}

updateUser(model: RegisteredUserModel): Observable<any> {
  return this.baseService.post('User/UpdateUser', JSON.stringify(model), this.options);
}

updateUserStatus(model: RegisteredUserModel): Observable<any> {
  return this.baseService.post('User/UpdateUserStatus', JSON.stringify(model), this.options);
}

getAllDepartments(): Observable<any> {
  return this.baseService.get<any>('Department/GetAllDepartments');
}

addApprovers(model: ApproverMapModel): Observable<any> {
  return this.baseService.post('ApproverMapping/AddApprovers', JSON.stringify(model), this.options);
}

updateApprovers(model: ApproverMapModel): Observable<any> {
  return this.baseService.post('ApproverMapping/UpdateApprovers', JSON.stringify(model), this.options);
}

addDepartment(model: DepartmentModel): Observable<any> {
  return this.baseService.post('Department/AddDepartment', JSON.stringify(model), this.options);
}

updateDepartment(model: DepartmentModel): Observable<any> {
  return this.baseService.post('Department/UpdateDepartment', JSON.stringify(model), this.options);
}

deleteDepartment(model: DepartmentModel): Observable<any> {
  return this.baseService.post('Department/DeleteDepartment', JSON.stringify(model), this.options);
}

getAllSubDeptMapping(skipLoader: boolean = false): Observable<any> {
  return this.baseService.get<any>('SubDepartment/GetAllSubDepartmentsMapping', skipLoader ? this.httpLoaderHeader : {});
}

addSubDept(model: SubDepartmentModel): Observable<any> {
  return this.baseService.post('SubDepartment/AddSubDept', JSON.stringify(model), this.options);
}

updateSubDept(model: SubDepartmentModel): Observable<any> {
  return this.baseService.post('SubDepartment/UpdateSubDept', JSON.stringify(model), this.options);
}

deleteSubDept(model: SubDepartmentModel): Observable<any> {
  return this.baseService.post('SubDepartment/DeleteSubDept', JSON.stringify(model), this.options);
}


getAllCompany(): Observable<any> {
  return this.baseService.get<any>('Company/GetAllCompany');
}

addCompany(model: CompanyModel): Observable<any> {
  return this.baseService.post('Company/AddCompany', JSON.stringify(model), this.options);
}

updateCompany(model: CompanyModel): Observable<any> {
  return this.baseService.post('Company/UpdateCompany', JSON.stringify(model), this.options);
}

deleteCompany(model: CompanyModel): Observable<any> {
  return this.baseService.post('Company/DeleteCompany', JSON.stringify(model), this.options);
}

GetAllCompanyAndBlock(): Observable<any> {
  return this.baseService.get<any>('Company/GetAllCompanyAndBlock');
}

getAllHolidays(): Observable<any> {
  return this.baseService.get<any>('Holiday/GetAllHolidays');
}

addHoliday(model: HolidayModel): Observable<any> {
  return this.baseService.post('Holiday/AddHoliday', JSON.stringify(model), this.options);
}

deleteHoliday(holidayId : any, userId: any): Observable<any> {
  return this.baseService.post('Holiday/DeleteHoliday?holidayId=' + holidayId + '&userId=' + userId, this.options);
}
}
